import script from "./home-footer.vue?vue&type=script&lang=ts&setup=true"
export * from "./home-footer.vue?vue&type=script&lang=ts&setup=true"

import "./home-footer.vue?vue&type=style&index=0&id=a1d2e0c6&lang=scss"

const __exports__ = script;

export default __exports__